import styled from 'styled-components';

export const HeaderSidebarBottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  align-content: center;
  row-gap: 5px;
  padding: 1rem;
  .hsb-divider {
    align-self: stretch;
    height: 1.2px;
    background-color: #dddddd;
    margin: 0.5rem 1rem;
  }
  .hsb-item {
    box-sizing: border-box;
    font-size: 1.8rem;
    margin-top: 0.5rem;
    padding: 0.5rem 1rem;
    width: fit-content;
    word-wrap: wrap none;
    text-align: left;
    height: 100%;
    color: var(--color-black);
    text-decoration: none;
  }
`;
